import React, {FC} from 'react';
import {Grid} from "@mui/material";
import {SortFilterContainer} from "../../common/reports/sortFilter/SortFilterContainer";
import {SortFilterItemContainer} from "../../common/reports/sortFilter/SortFilterItemContainer";
import { SortFilterRowContainer } from '../../common/reports/sortFilter';
import {
  sortByFields,
  LocationFavoriteSortByType,
  LocationFavoriteSortParams
} from "../../../types/model/params/sortParams/LocationFavoriteSortParams";
import { BoundSearchQuery } from "../../../types/common/BoundSearchQuery";
import { BuyerLocationFavoriteSearchCriteria } from "../../../types/model/criteria/locationFavorite/BuyerLocationFavoriteSearchCriteria";
import { PageableParams } from "../../../types/model/params/PageableParams";
import { optionsEndpoints } from "../../../requests/api-endpoints";
import {
  BoundSortSelect,
  BoundEquipmentTypeAutocomplete,
  BoundDataDrivenAutocomplete
} from "../../common/inputs/boundInputs";

export interface LocationFavoriteSearchParams extends BuyerLocationFavoriteSearchCriteria, LocationFavoriteSortParams, PageableParams, BoundSearchQuery {}

export interface BuyerLocationSortFilterProps {
  query: LocationFavoriteSearchParams;
  onChange: (newQuery: LocationFavoriteSearchParams) => void;
}

const BuyerLocationFavoriteSortFilter: FC<BuyerLocationSortFilterProps> = ({
  query,
  onChange
}) => {

  return <SortFilterContainer>
    <SortFilterRowContainer>
      <Grid container item spacing={2}>
        <SortFilterItemContainer>
          <BoundDataDrivenAutocomplete<LocationFavoriteSearchParams>
            label="City"
            requestUrl={optionsEndpoints.buyer.locationFavorite.city}
            name="city"
            value={query?.city}
            onChange={onChange}
          />
        </SortFilterItemContainer>
        <SortFilterItemContainer>
          <BoundDataDrivenAutocomplete<LocationFavoriteSearchParams>
            label="State"
            requestUrl={optionsEndpoints.buyer.locationFavorite.state}
            name="state"
            value={query?.state}
            onChange={onChange}
          />
        </SortFilterItemContainer>
        <SortFilterItemContainer>
          <BoundEquipmentTypeAutocomplete<LocationFavoriteSearchParams>
            name="equipmentType"
            value={query?.equipmentType}
            onChange={onChange}
          />
        </SortFilterItemContainer>
      </Grid>
      <Grid item>
        <SortFilterItemContainer sm={3}>
          <BoundSortSelect<LocationFavoriteSearchParams, LocationFavoriteSortByType>
            query={query}
            defaultSortBy="LOCATION_NAME"
            defaultSortDir="asc"
            sortByFields={sortByFields}
            onChange={onChange}
          />
        </SortFilterItemContainer>
      </Grid>
    </SortFilterRowContainer>
  </SortFilterContainer>
}

export { BuyerLocationFavoriteSortFilter };
